import _regeneratorRuntime from "C:\\Users\\TANLONGBIN\\avident\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\TANLONGBIN\\avident\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "C:\\Users\\TANLONGBIN\\avident\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _assertThisInitialized from "C:\\Users\\TANLONGBIN\\avident\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "C:\\Users\\TANLONGBIN\\avident\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\TANLONGBIN\\avident\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\TANLONGBIN\\avident\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\TANLONGBIN\\avident\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\TANLONGBIN\\avident\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { __rest } from 'tslib';
import React__default, { Component } from 'react';
import { Redirect, Route, matchPath, withRouter, BrowserRouter } from 'react-router-dom';
import { NavContext, IonLifeCycleContext, DefaultIonLifeCycleContext } from '@ionic/react';
var count = 0;

var generateId = function generateId() {
  return (count++).toString();
};

var isDevMode = function isDevMode() {
  return process && process.env && process.env.NODE_ENV === 'development';
};

var deprecationWarning = function deprecationWarning(message) {
  if (isDevMode()) {
    console.warn(message);
  }
};
/**
 * The View component helps manage the IonPage's lifecycle and registration
 */


var View =
/*#__PURE__*/
function (_React__default$Compo) {
  _inherits(View, _React__default$Compo);

  function View() {
    _classCallCheck(this, View);

    return _possibleConstructorReturn(this, _getPrototypeOf(View).apply(this, arguments));
  }

  _createClass(View, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /**
       * If we can tell if view is a redirect, hide it so it will work again in future
       */
      var view = this.props.view;

      if (view.route.type === Redirect) {
        this.props.onHideView(view.id);
      } else if (view.route.type === Route && view.route.props.render) {
        if (view.route.props.render().type === Redirect) {
          this.props.onHideView(view.id);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.ionPage) {
        this.ionPage.removeEventListener('ionViewWillEnter', this.ionViewWillEnterHandler.bind(this));
        this.ionPage.removeEventListener('ionViewDidEnter', this.ionViewDidEnterHandler.bind(this));
        this.ionPage.removeEventListener('ionViewWillLeave', this.ionViewWillLeaveHandler.bind(this));
        this.ionPage.removeEventListener('ionViewDidLeave', this.ionViewDidLeaveHandler.bind(this));
      }
    }
  }, {
    key: "ionViewWillEnterHandler",
    value: function ionViewWillEnterHandler() {
      this.context.ionViewWillEnter();
    }
  }, {
    key: "ionViewDidEnterHandler",
    value: function ionViewDidEnterHandler() {
      this.context.ionViewDidEnter();
    }
  }, {
    key: "ionViewWillLeaveHandler",
    value: function ionViewWillLeaveHandler() {
      this.context.ionViewWillLeave();
    }
  }, {
    key: "ionViewDidLeaveHandler",
    value: function ionViewDidLeaveHandler() {
      this.context.ionViewDidLeave();
    }
  }, {
    key: "registerIonPage",
    value: function registerIonPage(page) {
      this.ionPage = page;
      this.ionPage.addEventListener('ionViewWillEnter', this.ionViewWillEnterHandler.bind(this));
      this.ionPage.addEventListener('ionViewDidEnter', this.ionViewDidEnterHandler.bind(this));
      this.ionPage.addEventListener('ionViewWillLeave', this.ionViewWillLeaveHandler.bind(this));
      this.ionPage.addEventListener('ionViewDidLeave', this.ionViewDidLeaveHandler.bind(this));
      this.ionPage.classList.add('ion-page-invisible');

      if (isDevMode()) {
        this.ionPage.setAttribute('data-view-id', this.props.view.id);
      }

      this.props.onViewSync(page, this.props.view.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return React__default.createElement(NavContext.Consumer, null, function (value) {
        var newProvider = Object.assign({}, value, {
          registerIonPage: _this.registerIonPage.bind(_this)
        });
        return React__default.createElement(NavContext.Provider, {
          value: newProvider
        }, _this.props.children);
      });
    }
  }], [{
    key: "contextType",
    get: function get() {
      return IonLifeCycleContext;
    }
  }]);

  return View;
}(React__default.Component);
/**
 * The holistic view of all the Routes configured for an application inside of an IonRouterOutlet.
 */


var ViewStacks =
/*#__PURE__*/
function () {
  function ViewStacks() {
    _classCallCheck(this, ViewStacks);

    this.viewStacks = {};
  }

  _createClass(ViewStacks, [{
    key: "get",
    value: function get(key) {
      return this.viewStacks[key];
    }
  }, {
    key: "set",
    value: function set(key, viewStack) {
      this.viewStacks[key] = viewStack;
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return Object.keys(this.viewStacks);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      delete this.viewStacks[key];
    }
  }, {
    key: "findViewInfoByLocation",
    value: function findViewInfoByLocation(location, key) {
      var _this2 = this;

      var view;
      var match;
      var viewStack;

      if (key) {
        viewStack = this.viewStacks[key];

        if (viewStack) {
          viewStack.views.some(matchView);
        }
      } else {
        var keys = this.getKeys();
        keys.some(function (key) {
          viewStack = _this2.viewStacks[key];
          return viewStack.views.some(matchView);
        });
      }

      var result = {
        view: view,
        viewStack: viewStack,
        match: match
      };
      return result;

      function matchView(v) {
        var matchProps = {
          exact: v.routeData.childProps.exact,
          path: v.routeData.childProps.path || v.routeData.childProps.from,
          component: v.routeData.childProps.component
        };
        match = matchPath(location.pathname, matchProps);

        if (match) {
          view = v;
          return true;
        }

        return false;
      }
    }
  }, {
    key: "findViewInfoById",
    value: function findViewInfoById() {
      var _this3 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var view;
      var viewStack;
      var keys = this.getKeys();
      keys.some(function (key) {
        var vs = _this3.viewStacks[key];
        view = vs.views.find(function (x) {
          return x.id === id;
        });

        if (view) {
          viewStack = vs;
          return true;
        } else {
          return false;
        }
      });
      return {
        view: view,
        viewStack: viewStack
      };
    }
  }, {
    key: "setHiddenViews",
    value: function setHiddenViews() {
      var _this4 = this;

      var keys = this.getKeys();
      keys.forEach(function (key) {
        var viewStack = _this4.viewStacks[key];
        viewStack.views.forEach(function (view) {
          if (!view.routeData.match && !view.isIonRoute) {
            view.show = false;
            view.mount = false;
          }
        });
      });
    }
  }]);

  return ViewStacks;
}();

var RouteManagerContext =
/*@__PURE__*/
React__default.createContext({
  viewStacks: new ViewStacks(),
  syncView: function syncView() {
    navContextNotFoundError();
  },
  hideView: function hideView() {
    navContextNotFoundError();
  },
  setupIonRouter: function setupIonRouter() {
    return Promise.reject(navContextNotFoundError());
  },
  removeViewStack: function removeViewStack() {
    navContextNotFoundError();
  },
  transitionView: function transitionView() {
    navContextNotFoundError();
  }
});

function navContextNotFoundError() {
  console.error('IonReactRouter not found, did you add it to the app?');
}
/**
 * Manages the View's DOM lifetime by keeping it around long enough to complete page transitions before removing it.
 */


var ViewTransitionManager =
/*#__PURE__*/
function (_React__default$Compo2) {
  _inherits(ViewTransitionManager, _React__default$Compo2);

  function ViewTransitionManager(props) {
    var _this5;

    _classCallCheck(this, ViewTransitionManager);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ViewTransitionManager).call(this, props));
    _this5.ionLifeCycleContext = new DefaultIonLifeCycleContext();
    _this5._isMounted = false;
    _this5.state = {
      show: true
    };

    _this5.ionLifeCycleContext.onComponentCanBeDestroyed(function () {
      if (!_this5.props.mount) {
        if (_this5._isMounted) {
          _this5.setState({
            show: false
          }, function () {
            _this5.context.hideView(_this5.props.id);
          });
        }
      }
    });

    return _this5;
  }

  _createClass(ViewTransitionManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var show = this.state.show;
      return React__default.createElement(IonLifeCycleContext.Provider, {
        value: this.ionLifeCycleContext
      }, show && this.props.children);
    }
  }], [{
    key: "contextType",
    get: function get() {
      return RouteManagerContext;
    }
  }]);

  return ViewTransitionManager;
}(React__default.Component);

var StackManager =
/*#__PURE__*/
function (_React__default$Compo3) {
  _inherits(StackManager, _React__default$Compo3);

  function StackManager(props) {
    var _this6;

    _classCallCheck(this, StackManager);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(StackManager).call(this, props));
    _this6.routerOutletEl = React__default.createRef();
    _this6.id = _this6.props.id || generateId();
    _this6.handleViewSync = _this6.handleViewSync.bind(_assertThisInitialized(_this6));
    _this6.handleHideView = _this6.handleHideView.bind(_assertThisInitialized(_this6));
    return _this6;
  }

  _createClass(StackManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.setupIonRouter(this.id, this.props.children, this.routerOutletEl.current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.removeViewStack(this.id);
    }
  }, {
    key: "handleViewSync",
    value: function handleViewSync(page, viewId) {
      this.context.syncView(page, viewId);
    }
  }, {
    key: "handleHideView",
    value: function handleHideView(viewId) {
      this.context.hideView(viewId);
    }
  }, {
    key: "renderChild",
    value: function renderChild(item) {
      var component = React__default.cloneElement(item.route, {
        computedMatch: item.routeData.match
      });
      return component;
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var context = this.context;
      var viewStack = context.viewStacks.get(this.id);
      var views = (viewStack || {
        views: []
      }).views.filter(function (x) {
        return x.show;
      });
      var ionRouterOutlet = React__default.Children.only(this.props.children);
      var childElements = views.map(function (view) {
        return React__default.createElement(ViewTransitionManager, {
          id: view.id,
          key: view.key,
          mount: view.mount
        }, React__default.createElement(View, {
          onViewSync: _this7.handleViewSync,
          onHideView: _this7.handleHideView,
          view: view
        }, _this7.renderChild(view)));
      });
      var elementProps = {
        ref: this.routerOutletEl
      };

      if (isDevMode()) {
        elementProps['data-stack-id'] = this.id;
      }

      var routerOutletChild = React__default.cloneElement(ionRouterOutlet, elementProps, childElements);
      return routerOutletChild;
    }
  }], [{
    key: "contextType",
    get: function get() {
      return RouteManagerContext;
    }
  }]);

  return StackManager;
}(React__default.Component);

var RESTRICT_SIZE = 25;

var LocationHistory =
/*#__PURE__*/
function () {
  function LocationHistory() {
    _classCallCheck(this, LocationHistory);

    this.locationHistory = [];
  }

  _createClass(LocationHistory, [{
    key: "add",
    value: function add(location) {
      this.locationHistory.push(location);

      if (this.locationHistory.length > RESTRICT_SIZE) {
        this.locationHistory.splice(0, 10);
      }
    }
  }, {
    key: "findLastLocation",
    value: function findLastLocation(url) {
      var reversedLocations = _toConsumableArray(this.locationHistory).reverse();

      var last = reversedLocations.find(function (x) {
        return x.pathname.toLowerCase() === url.toLowerCase();
      });
      return last;
    }
  }]);

  return LocationHistory;
}();

var NavManager =
/*#__PURE__*/
function (_React__default$Compo4) {
  _inherits(NavManager, _React__default$Compo4);

  function NavManager(props) {
    var _this8;

    _classCallCheck(this, NavManager);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(NavManager).call(this, props));
    _this8.locationHistory = new LocationHistory();
    _this8.state = {
      goBack: _this8.goBack.bind(_assertThisInitialized(_this8)),
      hasIonicRouter: function hasIonicRouter() {
        return true;
      },
      getHistory: _this8.getHistory.bind(_assertThisInitialized(_this8)),
      getLocation: _this8.getLocation.bind(_assertThisInitialized(_this8)),
      navigate: _this8.navigate.bind(_assertThisInitialized(_this8)),
      getStackManager: _this8.getStackManager.bind(_assertThisInitialized(_this8)),
      getPageManager: _this8.getPageManager.bind(_assertThisInitialized(_this8)),
      currentPath: _this8.props.location.pathname,
      registerIonPage: function registerIonPage() {} //overridden in View for each IonPage

    };
    _this8.listenUnregisterCallback = _this8.props.history.listen(function (location) {
      _this8.setState({
        currentPath: location.pathname
      });

      _this8.locationHistory.add(location);
    });

    _this8.locationHistory.add({
      hash: window.location.hash,
      key: generateId(),
      pathname: window.location.pathname,
      search: window.location.search,
      state: {}
    });

    return _this8;
  }

  _createClass(NavManager, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.listenUnregisterCallback) {
        this.listenUnregisterCallback();
      }
    }
  }, {
    key: "goBack",
    value: function goBack(defaultHref) {
      var _this$props$getActive = this.props.getActiveIonPage(),
          activeIonPage = _this$props$getActive.view;

      if (activeIonPage) {
        var _this$props$findViewI = this.props.findViewInfoById(activeIonPage.prevId),
            enteringView = _this$props$findViewI.view;

        if (enteringView) {
          var lastLocation = this.locationHistory.findLastLocation(enteringView.routeData.match.url);

          if (lastLocation) {
            this.props.history.replace(lastLocation.pathname + lastLocation.search, {
              direction: 'back'
            });
          } else {
            this.props.history.replace(enteringView.routeData.match.url, {
              direction: 'back'
            });
          }
        } else {
          defaultHref && this.props.history.replace(defaultHref, {
            direction: 'back'
          });
        }
      } else {
        defaultHref && this.props.history.replace(defaultHref, {
          direction: 'back'
        });
      }
    }
  }, {
    key: "getHistory",
    value: function getHistory() {
      return this.props.history;
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      return this.props.location;
    }
  }, {
    key: "navigate",
    value: function navigate(path, direction) {
      this.props.history.push(path, {
        direction: direction
      });
    }
  }, {
    key: "getPageManager",
    value: function getPageManager() {
      return function (children) {
        return children;
      };
    }
  }, {
    key: "getStackManager",
    value: function getStackManager() {
      return StackManager;
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement(NavContext.Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return NavManager;
}(React__default.Component);

var RouteManager =
/*#__PURE__*/
function (_React__default$Compo5) {
  _inherits(RouteManager, _React__default$Compo5);

  function RouteManager(props) {
    var _this9;

    _classCallCheck(this, RouteManager);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(RouteManager).call(this, props));
    _this9.listenUnregisterCallback = _this9.props.history.listen(_this9.historyChange.bind(_assertThisInitialized(_this9)));
    _this9.state = {
      viewStacks: new ViewStacks(),
      hideView: _this9.hideView.bind(_assertThisInitialized(_this9)),
      setupIonRouter: _this9.setupIonRouter.bind(_assertThisInitialized(_this9)),
      removeViewStack: _this9.removeViewStack.bind(_assertThisInitialized(_this9)),
      syncView: _this9.syncView.bind(_assertThisInitialized(_this9)),
      transitionView: _this9.transitionView.bind(_assertThisInitialized(_this9))
    };
    return _this9;
  }

  _createClass(RouteManager, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      // Trigger a page change if the location or action is different
      if (this.state.location && prevState.location !== this.state.location || prevState.action !== this.state.action) {
        this.setActiveView(this.state.location, this.state.action);
      }
    }
  }, {
    key: "hideView",
    value: function hideView(viewId) {
      var viewStacks = Object.assign(new ViewStacks(), this.state.viewStacks);

      var _viewStacks$findViewI = viewStacks.findViewInfoById(viewId),
          view = _viewStacks$findViewI.view;

      if (view) {
        view.show = false;
        view.ionPageElement = undefined;
        view.isIonRoute = false;
        view.prevId = undefined;
        view.key = generateId();
        this.setState({
          viewStacks: viewStacks
        });
      }
    }
  }, {
    key: "historyChange",
    value: function historyChange(location, action) {
      this.setState({
        location: location,
        action: action
      });
    }
  }, {
    key: "setActiveView",
    value: function setActiveView(location, action) {
      var _this10 = this;

      var viewStacks = Object.assign(new ViewStacks(), this.state.viewStacks);
      var direction = location.state && location.state.direction || 'forward';
      var leavingView;
      var viewStackKeys = viewStacks.getKeys();
      viewStackKeys.forEach(function (key) {
        var _viewStacks$findViewI2 = viewStacks.findViewInfoByLocation(location, key),
            enteringView = _viewStacks$findViewI2.view,
            enteringViewStack = _viewStacks$findViewI2.viewStack,
            match = _viewStacks$findViewI2.match;

        if (!enteringView || !enteringViewStack) {
          return;
        }

        leavingView = viewStacks.findViewInfoById(_this10.activeIonPageId).view;

        if (enteringView) {
          if (enteringView.isIonRoute) {
            enteringView.show = true;
            enteringView.mount = true;
            enteringView.routeData.match = match;
            _this10.activeIonPageId = enteringView.id;

            if (leavingView) {
              if (direction === 'forward') {
                if (action === 'PUSH') {
                  /**
                  * If the page is being pushed into the stack by another view,
                  * record the view that originally directed to the new view for back button purposes.
                  */
                  enteringView.prevId = enteringView.prevId || leavingView.id;
                } else {
                  direction = direction || 'back';
                  leavingView.mount = false;
                }
              } else if (action === 'REPLACE') {
                leavingView.mount = false;
              }
            }
          } else {
            enteringView.show = true;
            enteringView.mount = true;
            enteringView.routeData.match = match;
          }
        }
      });

      if (leavingView) {
        if (!leavingView.isIonRoute) {
          leavingView.mount = false;
          leavingView.show = false;
        }
      }

      this.setState({
        viewStacks: viewStacks
      }, function () {
        var _this10$state$viewSta = _this10.state.viewStacks.findViewInfoById(_this10.activeIonPageId),
            enteringView = _this10$state$viewSta.view,
            viewStack = _this10$state$viewSta.viewStack;

        if (enteringView && viewStack) {
          var enteringEl = enteringView.ionPageElement ? enteringView.ionPageElement : undefined;
          var leavingEl = leavingView && leavingView.ionPageElement ? leavingView.ionPageElement : undefined;

          if (enteringEl) {
            // Don't animate from an empty view
            var navDirection = leavingEl && leavingEl.innerHTML === '' ? undefined : direction === 'none' ? undefined : direction;

            _this10.transitionView(enteringEl, leavingEl, viewStack.routerOutlet, navDirection);
          } else if (leavingEl) {
            leavingEl.classList.add('ion-page-hidden');
            leavingEl.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.listenUnregisterCallback && this.listenUnregisterCallback();
    }
  }, {
    key: "setupIonRouter",
    value: function () {
      var _setupIonRouter = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(id, children, routerOutlet) {
        var _this11 = this;

        var views, activeId, ionRouterOutlet, createViewItem;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                createViewItem = function _ref(child, location) {
                  var viewId = generateId();
                  var key = generateId();
                  var route = child;
                  var matchProps = {
                    exact: child.props.exact,
                    path: child.props.path || child.props.from,
                    component: child.props.component
                  };
                  var match = matchPath(location.pathname, matchProps);
                  var view = {
                    id: viewId,
                    key: key,
                    routeData: {
                      match: match,
                      childProps: child.props
                    },
                    route: route,
                    mount: true,
                    show: !!match,
                    isIonRoute: false
                  };

                  if (!!match && view.isIonRoute) {
                    activeId = viewId;
                  }

                  return view;
                };

                views = [];
                ionRouterOutlet = React__default.Children.only(children);
                React__default.Children.forEach(ionRouterOutlet.props.children, function (child) {
                  views.push(createViewItem(child, _this11.props.history.location));
                });
                _context.next = 6;
                return this.registerViewStack(id, activeId, views, routerOutlet, this.props.location);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setupIonRouter(_x, _x2, _x3) {
        return _setupIonRouter.apply(this, arguments);
      }

      return setupIonRouter;
    }()
  }, {
    key: "registerViewStack",
    value: function () {
      var _registerViewStack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(stack, activeId, stackItems, routerOutlet, _location) {
        var _this12 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve) {
                  _this12.setState(function (prevState) {
                    var prevViewStacks = Object.assign(new ViewStacks(), prevState.viewStacks);
                    var newStack = {
                      id: stack,
                      views: stackItems,
                      routerOutlet: routerOutlet
                    };

                    if (activeId) {
                      _this12.activeIonPageId = activeId;
                    }

                    prevViewStacks.set(stack, newStack);
                    return {
                      viewStacks: prevViewStacks
                    };
                  }, function () {
                    resolve();
                  });
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function registerViewStack(_x4, _x5, _x6, _x7, _x8) {
        return _registerViewStack.apply(this, arguments);
      }

      return registerViewStack;
    }()
  }, {
    key: "removeViewStack",
    value: function removeViewStack(stack) {
      var viewStacks = Object.assign(new ViewStacks(), this.state.viewStacks);
      viewStacks.delete(stack);
      this.setState({
        viewStacks: viewStacks
      });
    }
  }, {
    key: "syncView",
    value: function syncView(page, viewId) {
      var _this13 = this;

      this.setState(function (state) {
        var viewStacks = Object.assign(new ViewStacks(), state.viewStacks);

        var _viewStacks$findViewI3 = viewStacks.findViewInfoById(viewId),
            view = _viewStacks$findViewI3.view;

        view.ionPageElement = page;
        view.isIonRoute = true;
        return {
          viewStacks: viewStacks
        };
      }, function () {
        _this13.setActiveView(_this13.state.location || _this13.props.location, _this13.state.action);
      });
    }
  }, {
    key: "transitionView",
    value: function transitionView(enteringEl, leavingEl, ionRouterOutlet, direction) {
      var _this14 = this;

      /**
       * Super hacky workaround to make sure ionRouterOutlet is available
       * since transitionView might be called before IonRouterOutlet is fully mounted
       */
      if (ionRouterOutlet && ionRouterOutlet.componentOnReady) {
        this.commitView(enteringEl, leavingEl, ionRouterOutlet, direction);
      } else {
        setTimeout(function () {
          _this14.transitionView(enteringEl, leavingEl, ionRouterOutlet, direction);
        }, 10);
      }
    }
  }, {
    key: "commitView",
    value: function () {
      var _commitView = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(enteringEl, leavingEl, ionRouterOuter, direction) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(enteringEl === leavingEl)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.next = 4;
                return ionRouterOuter.commit(enteringEl, leavingEl, {
                  deepWait: true,
                  duration: direction === undefined ? 0 : undefined,
                  direction: direction,
                  showGoBack: direction === 'forward',
                  progressAnimation: false
                });

              case 4:
                if (leavingEl && enteringEl !== leavingEl) {
                  /** add hidden attributes */
                  leavingEl.classList.add('ion-page-hidden');
                  leavingEl.setAttribute('aria-hidden', 'true');
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function commitView(_x9, _x10, _x11, _x12) {
        return _commitView.apply(this, arguments);
      }

      return commitView;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this15 = this;

      return React__default.createElement(RouteManagerContext.Provider, {
        value: this.state
      }, React__default.createElement(NavManager, Object.assign({}, this.props, {
        findViewInfoById: function findViewInfoById(id) {
          return _this15.state.viewStacks.findViewInfoById(id);
        },
        findViewInfoByLocation: function findViewInfoByLocation(location) {
          return _this15.state.viewStacks.findViewInfoByLocation(location);
        },
        getActiveIonPage: function getActiveIonPage() {
          return _this15.state.viewStacks.findViewInfoById(_this15.activeIonPageId);
        }
      }), this.props.children));
    }
  }]);

  return RouteManager;
}(React__default.Component);

var RouteManagerWithRouter = withRouter(RouteManager);
RouteManagerWithRouter.displayName = 'RouteManager';

var IonReactRouter =
/*#__PURE__*/
function (_React__default$Compo6) {
  _inherits(IonReactRouter, _React__default$Compo6);

  function IonReactRouter() {
    _classCallCheck(this, IonReactRouter);

    return _possibleConstructorReturn(this, _getPrototypeOf(IonReactRouter).apply(this, arguments));
  }

  _createClass(IonReactRouter, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          props = __rest(_a, ["children"]);

      return React__default.createElement(BrowserRouter, Object.assign({}, props), React__default.createElement(RouteManagerWithRouter, null, children));
    }
  }]);

  return IonReactRouter;
}(React__default.Component);

var ViewManager =
/*#__PURE__*/
function (_Component) {
  _inherits(ViewManager, _Component);

  function ViewManager() {
    _classCallCheck(this, ViewManager);

    return _possibleConstructorReturn(this, _getPrototypeOf(ViewManager).apply(this, arguments));
  }

  _createClass(ViewManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      deprecationWarning('As of @ionic/react RC2, ViewManager is no longer needed and can be removed. This component is now deprecated will be removed from @ionic/react final.');
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return ViewManager;
}(Component);

export { IonReactRouter, ViewManager };